// extracted by mini-css-extract-plugin
export default {"titleContainer":"TableCard_titleContainer__YGbgd","cardMainDiv":"TableCard_cardMainDiv__Yz9GL","cardMainDivMob":"TableCard_cardMainDivMob__BkDSM"};